import { BrowserRouter as Router } from "react-router-dom";
import React from "react";
import { AnimatedRoutes } from "./components";

function App() {
  return (
    <Router>
      <AnimatedRoutes />
    </Router>
  );
}

export default App;
